<div class="page-body">
  <div *ngIf="internalServerError" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">{{ translations.errorHeading }}</h3>
      <p class="info-text">{{ translations.errorInfo }}</p>
    </div>
  </div>

  <div *ngIf="loading && !internalServerError">
    <app-spinner [infoText]="translations.loading"></app-spinner>
  </div>

  <div
    *ngIf="!loading && currentView === View.DEFAULT && !internalServerError"
    class="contents-wrapper"
  >
    <div class="contents-container">
      <h1 class="heading">
        {{ translations.formHeading }}
      </h1>
      <form [formGroup]="form" id="email-and-phone-form">
        <div class="input-container">
          <zaver-animated-form-input
            size="large"
            formControlName="email"
            inputMode="email"
            autoComplete="email"
            inputType="email"
            errorIcon="assets/icon/icon_error.svg"
            [error]="form.controls.email.invalid && showError"
            [placeholder]="translations.emailPlaceholder"
            [errorMessage]="translations.emailErrorMessage"
          ></zaver-animated-form-input>
        </div>

        <div class="input-container">
          <zaver-animated-form-input
            size="large"
            formControlName="phoneNumber"
            inputMode="tel"
            autoComplete="tel"
            inputType="tel"
            errorIcon="assets/icon/icon_error.svg"
            [error]="form.controls.phoneNumber.invalid && showError"
            [placeholder]="translations.phonePlaceholder"
            [errorMessage]="translations.phoneErrorMessage"
            [showContent]="true"
            ><zaver-select-country
              buttonId="select-country-code"
              [isMobile]="isMobile"
              [items]="AVAILABLECOUNTRYCODES"
              [selectedItem]="selectedCountry"
              (itemSelected)="setCountry($event)"
            ></zaver-select-country>
          </zaver-animated-form-input>
        </div>
      </form>

      <app-general-error
        *ngIf="form.valid && noResponseError"
        class="form-error"
      ></app-general-error>

      <div class="footer-wrapper">
        <div class="footer-container">
          <div class="total-amount" *ngIf="state.totalCheckoutValue">
            <p>{{ translations.amount }}</p>
            <p>{{ state.totalCheckoutValue | value }}</p>
          </div>

          <div class="button-container">
            <zaver-primary-button
              buttonType="submit"
              formId="email-and-phone-form"
              [text]="translations.continueButton"
              [disabled]="navigationInProgress"
              (click)="handleCtaClick()"
            ></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="!loading && currentView === View.NOT_FOUND && !internalServerError"
    class="contents-wrapper"
  >
    <div class="contents-container">
      <div class="footer-wrapper">
        <div class="footer-container">
          <h3 class="heading">{{ translations.notFoundErrorHeader }}</h3>
          <p class="info-text">
            {{ translations.notFoundErrorInfo }}
          </p>

          <div class="account-details-wrapper">
            <p class="email">{{ form.controls.email.value }}</p>
            <p class="phone">{{ form.controls.phoneNumber.value }}</p>
          </div>

          <div class="button-container">
            <zaver-primary-button
              [text]="translations.editButton"
              [disabled]="navigationInProgress"
              (click)="setCurrentView(View.DEFAULT)"
            ></zaver-primary-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
